/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {formatDate} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FabMessageService} from '@fabric/components/message';
import {DISMISS_MSG} from '../../../../common/constants';
import {ExcelExportService} from '../../../../services/excel-export.service';
import {ReportService} from '../../../../services/report.service';
import {VehiclePortfolioLoadService} from '../../../../services/vehicle-portfolio-load.service';

@Component({
    selector: 'app-portfolio-archive-report',
    templateUrl: './portfolio-archive-report.component.html',
    styleUrl: './portfolio-archive-report.component.scss',
    standalone: false
})
export class PortfolioArchiveReportComponent implements OnInit {
  showSpinner: boolean;
  archiveList: string[];
  selectedArchive: string;


  constructor(readonly reportService: ReportService,
              readonly vehPortfolioService: VehiclePortfolioLoadService,
              readonly excelService: ExcelExportService,
              public snackBar: FabMessageService) {

  }

  ngOnInit(): void {
    this.getArchiveList();
  }

  /**
   * Get the archived portfolio report
   */
  getArchivedPorfolioReport(): void {
    const currDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    const fileName = this.selectedArchive + '_' + currDate;

    this.showSpinner = true;
    this.reportService.getArchivedPortfolioReport(this.selectedArchive).subscribe(
      {
        next: (data) => {
          this.excelService.exportToExcelFromServer(data, fileName);
        },
        error: (error) => {
          this.showSpinner = false;
          this.snackBar.displayError(error, DISMISS_MSG);
        },
        complete: () => {
          this.showSpinner = false;
          this.snackBar.displaySuccess('Successfully retrieved data. Exporting...', DISMISS_MSG);

        }
      }
    );
  }

  /**
   * Get all archived portfolios
   */
  getArchiveList(): void {
    this.showSpinner = true;
    this.vehPortfolioService.getArchivedPortfolios().subscribe((data: any) => {
      this.archiveList = data.map((archive: any) => archive.ARCHIVE_NAME);
    }, err => {
      this.showSpinner = false;
      this.snackBar.displayError(err, DISMISS_MSG);
    }, () => {
      this.showSpinner = false;
    });
  }
}
